import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';

const SempForm = ({ show, onHide, onSave, plan }) => {
    const initialFormData = {
        semp_no: '',
        semp_fdate: '',
        semp_tdate: '',
        semp_title: '',
        semp_pub_from: '',
        semp_pub_to: '',
        creator: '',
        changer: ''
    };

    const [formData, setFormData] = useState(initialFormData);

    useEffect(() => {
        if (plan) {
            // 날짜/시간 값에서 'T'를 공백으로 치환하여 datetime-local 형식에 맞춤
            const formatDateTimeLocal = (datetime) => datetime ? datetime.replace(' ', 'T') : '';
            setFormData({
                ...plan,
                semp_pub_from: formatDateTimeLocal(plan.semp_pub_from),
                semp_pub_to: formatDateTimeLocal(plan.semp_pub_to),
            });
        } else {
            setFormData(initialFormData);
        }
    }, [plan, show]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // datetime-local 형식에서 다시 DB 형식(공백 구분)으로 변경
        const submissionData = {
            ...formData,
            semp_pub_from: formData.semp_pub_from.replace('T', ' '),
            semp_pub_to: formData.semp_pub_to.replace('T', ' '),
        };
        onSave(submissionData);
    };

    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>{plan ? '계획 수정' : '새 계획 추가'}</Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column sm={2}>제목</Form.Label>
                        <Col sm={10}>
                            <Form.Control
                                type="text"
                                name="semp_title"
                                value={formData.semp_title}
                                onChange={handleChange}
                                required
                            />
                        </Col>
                    </Form.Group>

                    <Row className="mb-3">
                        <Form.Group as={Col}>
                            <Form.Label>시작일자</Form.Label>
                            <Form.Control
                                type="date"
                                name="semp_fdate"
                                value={formData.semp_fdate}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group as={Col}>
                            <Form.Label>종료일자</Form.Label>
                            <Form.Control
                                type="date"
                                name="semp_tdate"
                                value={formData.semp_tdate}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>
                    </Row>

                    <Row className="mb-3">
                        <Form.Group as={Col}>
                            <Form.Label>게시 시작일시</Form.Label>
                            <Form.Control
                                type="datetime-local"
                                name="semp_pub_from"
                                value={formData.semp_pub_from}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group as={Col}>
                            <Form.Label>게시 종료일시</Form.Label>
                            <Form.Control
                                type="datetime-local"
                                name="semp_pub_to"
                                value={formData.semp_pub_to}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>
                    </Row>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide}>취소</Button>
                    <Button variant="primary" type="submit">저장</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default SempForm;
